import { render } from "./PletivoVigente.vue?vue&type=template&id=0c3aa395"
import script from "./PletivoVigente.vue?vue&type=script&lang=js"
export * from "./PletivoVigente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__